module.exports = __webpack_public_path__ + "9c2b143e12a782f5b28532dcaf383f1a.fbx";